"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIBox;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _BoxConstants = require("./BoxConstants");

var _Styles = require("../utils/Styles");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  align-self: ", ";\n  flex-basis: ", ";\n  flex-grow: ", ";\n  flex-shrink: ", ";\n  order: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledBox = _styledComponents.default.div.withConfig({
  displayName: "UIBox__StyledBox",
  componentId: "jx4k5n-0"
})(_templateObject(), function (props) {
  return _BoxConstants.ALIGN_SELF_OPTIONS[props.alignSelf];
}, function (props) {
  return (0, _Styles.toPx)(props.basis);
}, function (props) {
  return props.grow;
}, function (props) {
  return props.shrink;
}, function (props) {
  return props.order;
});

function UIBox(_ref) {
  var className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["className"]);
  return _react.default.createElement(StyledBox, (0, _extends2.default)({}, rest, {
    className: (0, _classnames.default)('private-flex__child', className)
  }));
}

UIBox.defaultProps = {
  alignSelf: 'auto',
  basis: 'auto',
  grow: 0,
  flexOrder: 0,
  shrink: 1
};
UIBox.propTypes = {
  alignSelf: _propTypes.default.oneOf(Object.keys(_BoxConstants.ALIGN_SELF_OPTIONS)),
  basis: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  children: _propTypes.default.node,
  grow: _propTypes.default.number,
  shrink: _propTypes.default.number,
  order: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['inherit', 'initial', 'unset'])])
};
UIBox.displayName = 'UIBox';
module.exports = exports.default;